import React from "react";
import { HeaderStatsContainer } from "./HeaderStats.styles";

// might be a little redundant but it can be easily expanded upon

export const HeaderStats = ({ children }) => (
  <HeaderStatsContainer>{children}</HeaderStatsContainer>
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/HeaderStats/HeaderStats.js